const InnerContainerStyle = `
  height: 150px;
`;

export default InnerContainerStyle;
